import { DOCUMENT } from '@angular/common';
import { DestroyRef, Injectable, NgZone, inject, signal } from '@angular/core';

const POINTER_MOVE_THROTTLE_MS = 1_000;

/** When the user last used the app with a pointer or the keyboard, in epoch milliseconds. */
@Injectable({ providedIn: 'root' })
export class UserActivityService {
  private readonly at = signal(Date.now());
  readonly lastActivityAt = this.at.asReadonly();

  constructor() {
    const document = inject(DOCUMENT);
    const record = () => this.at.set(Date.now());
    const recordMove = () => {
      if (Date.now() - this.at() >= POINTER_MOVE_THROTTLE_MS) record();
    };
    // Capture phase, so a handler stopping propagation cannot hide activity; outside the zone, so
    // a pointer move does not run change detection.
    const options = { capture: true, passive: true };
    const listeners: [string, () => void][] = [
      ['pointerdown', record],
      ['keydown', record],
      ['pointermove', recordMove]
    ];
    inject(NgZone).runOutsideAngular(() => {
      for (const [type, listener] of listeners) {
        document.addEventListener(type, listener, options);
      }
    });
    inject(DestroyRef).onDestroy(() => {
      for (const [type, listener] of listeners) {
        document.removeEventListener(type, listener, options);
      }
    });
  }
}
